import {type ActiveRun} from 'src/state/issues/types';

// minimum version of sdk is 0.20.1
export function checkIfCliIsOutdated(run: ActiveRun | null) {
  if (!run) {
    return false;
  }
  try {
    const sdk = run?._wandb?.cli_version ?? run?._wandb?.['value.cli_version'];
    if (!sdk || typeof sdk !== 'string') {
      // if we can't determine the version assume it's valid
      return false;
    }
    const [major, minor, patch] = sdk.split('.').map(Number);
    if (major > 0) {
      return false;
    }

    if (major === 0 && minor > 20) {
      return false;
    }

    if (major === 0 && minor === 20) {
      if (patch < 1) {
        return true;
      } else {
        return false;
      }
    }

    if (major === 0 && minor < 20) {
      return true;
    }

    return true;
  } catch (e) {
    // any errors we'll log and swallow
    console.error(e);
    return false;
  }
}
